

$(function(){
    $(document).on("change", "[name=id].original-selector", function () {
        var selected = $(this).val();
        var variant = hc_product_variants.find(z => z.id == selected);
        console.log(variant);
        var gram = variant.metafields.find(z => z.key === 'gram').value;
        var pirlanta_rengi = variant.metafields.find(z => z.key === 'pirlanta_rengi').value;
        var carat_options = variant.metafields.find(z => z.key === 'carat_options').value;
        var pirlanta_berrakligi = variant.metafields.find(z => z.key === 'pirlanta_berrakligi').value;
        var pirlanta_kesimi = variant.metafields.find(z => z.key === 'pirlanta_kesimi').value;
        var d1_ = variant.metafields.find(z => z.key === 'd1_').value;
        var d2_ = variant.metafields.find(z => z.key === 'd2_').value;
        var d3_ = variant.metafields.find(z => z.key === 'd3_').value;
        var ot1isim = variant.metafields.find(z => z.key === 'ot1isim').value;
        var ot2isim = variant.metafields.find(z => z.key === 'ot2isim').value;
        var ot1ct = variant.metafields.find(z => z.key === 'ot1ct').value;
        var ot2ct = variant.metafields.find(z => z.key === 'ot2ct').value;
        var altin_renk = variant.metafields.find(z => z.key === 'altin_renk').value;
        var altin_ayar = variant.metafields.find(z => z.key === 'altin_ayar').value;
        var totalCarat = (parseFloat(d1_)+ parseFloat(d2_) + parseFloat(d3_)).toFixed(2);
      
        $('.variant-description-table .table-d1').text(d1_);
        $('.variant-description-table .table-d2').text(d2_);
        $('.variant-description-table .table-d3').text(d3_);
        $('.variant-description-table .table-ot1').text(ot1ct);
        $('.variant-description-table .table-ot2').text(ot2ct);
      
        $('.variant-description-table tbody tr td').eq(2).text(pirlanta_rengi);
        $('.variant-description-table tbody tr td').eq(3).text(pirlanta_berrakligi);
        $('.variant-description-table tbody tr td').eq(4).text(pirlanta_kesimi);
      

        $('.title-row h1.title span').text(totalCarat + ' ct ');
        gram = parseFloat(gram).toFixed(2);
        $('.description-dynamic').text(`${totalCarat} ct | ${pirlanta_rengi} | ${pirlanta_berrakligi} | ${gram} gr | ${altin_ayar} | ${altin_renk}`);  
    });
  
  if($('li.is-unavailable').length > 0 ) {
    $('li.is-unavailable').remove();
  }
  
  if($('.input-row .size-chart-container').length > 0 ) {
    $('.input-row .size-chart-container').remove();
  }
  
    if(($('.carat-digit').length > 0) ){
      updateElement('.title-row h1.title span');
      updateElement('.description-dynamic');
      updateElement('.input-row .cc-select__btn');
      for (let i = 0; i < hc_product_variants.length; i++) {
        updateElement('.input-row .digit-' + hc_product_variants[i].id + ' span:first');
      }
   }

    if($('.description-dynamic span').length > 0 ) {
      var fixedGram = parseFloat($('.description-dynamic span').html()).toFixed(2);
      if (!isNaN(fixedGram)) {
        $('.description-dynamic span').html(fixedGram + ' gr | ');
      }
    }
  
}) 

function updateElement(selector) {
  var element = $(selector);
  var value = element.html();
  if (value) {
    var splitValue = value.split('|');
    if (!isNaN(parseFloat(splitValue[0]))) {
      splitValue[0] = parseFloat(splitValue[0]).toFixed(2) + ' ct ';
    }
    element.html(splitValue.join(' | '));
  }
}

const selectedLanguage = document.querySelector('.selected-language');
const languageOptions = document.querySelector('.language-options');

selectedLanguage.addEventListener('click', () => {
  languageOptions.classList.toggle('show');
});

const languageList = document.querySelectorAll('.language-options li');

languageList.forEach((language) => {
  language.addEventListener('click', () => {
    const lang = language.getAttribute('data-lang');
    const img = language.querySelector('img').getAttribute('src');
    const name = language.querySelector('span').textContent;
    selectedLanguage.innerHTML = `
      <img src="${img}" alt="${name}">
      <span>${name}</span>
      <i class="fa fa-angle-down"></i>
    `;
    languageOptions.classList.remove('show');
  });
});

document.addEventListener('click', (event) => {
  if (!selectedLanguage.contains(event.target) && !languageOptions.contains(event.target)) {
    languageOptions.classList.remove('show');
  }
});

// Wait for cart to update
document.addEventListener("cart.updated", function(event) {
  // Get cart subtotal
  var subtotal = event.detail.items_subtotal_price;
  
  // Check if subtotal is over 400
  if (subtotal >= 400) {
    // Check if '8180966359333' product is already in cart
    var inCart = false;
    for (var i = 0; i < event.detail.items.length; i++) {
      if (event.detail.items[i].product_id == '8180966359333') {
        inCart = true;
        break;
      }
    }
    
    // Add '8180966359333' product if it's not already in cart and product is not tagged with 'disc5' or 'disc15'
    if (!inCart && event.detail.items.every(item => !item.product_tag.includes('disc5') && !item.product_tag.includes('disc15'))) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          quantity: 1,
          id: '8180966359333'
        })
      })
      .then(function(response) {
        window.location.reload();
      });
    }
  }
});